import { Classes, FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import DropdownSelect from "common/form/widgets/common/DropdownSelect";
import NumberWidget from "common/form/widgets/NumberWidget";
import IOption from "common/models/IOption";
import { ConditionTypeRegistry } from "../ConditionTypeRegistry";
import { IConditionType } from "../IConditionType";

interface IWindowSizeCondition {
	dimension: "width" | "height";
	operator: "gt" | "lt";
	breakpoint: number;
}

const dimensions: Array<IOption<'width' | 'height'>> = [
	{value: 'width', label: 'Width'},
	{value: 'height', label: 'Height'}
];

const operators: Array<IOption<'gt' | 'lt'>> = [
	{value: 'gt', label: '>'},
	{value: 'lt', label: '<'}
];

const WindowSizeCondition: IConditionType<IWindowSizeCondition> = {
	type: 'windowSize',
	label: 'Window Size',
	icon: IconNames.ARROWS_HORIZONTAL,
	evaluate: ({operator, dimension, breakpoint}) => {
		switch(dimension) {
			case 'height':
				if("gt" === operator) {
					return window.innerHeight > breakpoint;
				}
				return window.innerHeight < breakpoint;

			default: // default to "width"
				if("gt" === operator) {
					return window.innerWidth > breakpoint;
				}
				return window.innerWidth < breakpoint;
		}
	},
	renderPreview: ({dimension, operator, breakpoint}) => (
		<div>
			<span>
				Window width is {"gt" === operator && "greater" || "less"} than {breakpoint}
			</span>
			<div className={Classes.TEXT_MUTED}>
				The window is currently
				{"height" === dimension ? (
					<span> {window.innerHeight}px tall</span>
				) : (
					<span> {window.innerWidth}px wide</span>
				)}
			</div>
		</div>
	),
	renderField: (value, onChange) => {
		return (
			<React.Fragment>
				<FormGroup label="Dimension">
					<DropdownSelect
						options={dimensions}
						onChange={(dimension) => onChange({...value, dimension})}
						value={value.dimension}
					/>
				</FormGroup>
				<FormGroup label="Operator">
					<DropdownSelect
						options={operators}
						onChange={(operator) => onChange({...value, operator})}
						value={value.operator}
					/>
				</FormGroup>
				<FormGroup label="Breakpoint" helperText={"true when the page " + value.dimension + " is " + ("gt" === value.operator && "greather" || "less") + " than this value"}>
					<NumberWidget
						onChange={(breakpoint) => onChange({...value, breakpoint})}
						value={value.breakpoint}
					/>
				</FormGroup>
			</React.Fragment>

		);
	}
};

export default ConditionTypeRegistry.register(WindowSizeCondition);



// WEBPACK FOOTER //
// ./src/common/form/fields/condition/conditionTypes/WindowSizeCondition.reg.tsx